import { api } from './base';
import { Employee } from './employee.api';
import { Department } from './department.api';

export interface EmployeeAdminQuery {
  name: string;
  departmentId?: number | null;
  skip?: number;
  limit?: number;
}

export interface EmployeeOuterQuery {
  departmentId?: number | null;
  name?: string | null;
}

export interface EmployeeAdminSearchResult {
  employees: Array<Employee>;
  companies: Array<Department>;
  total: number;
}

export interface NewMailAccount {
  username: string;
  display_name: string;
  remark: string;
  mobile_phone_no?: string;
}

export const employeeAdminApis = {
  search(query: EmployeeAdminQuery) {
    let url = `/admin/employees`;
    if (query) {
      url += `?name=${query.name}`;
      if (query.departmentId) {
        url += `&department_id=${query.departmentId}`;
      }
      if (query.skip) {
        url += `&skip=${query.skip}`;
      }
      if (query.limit) {
        url += `&limit=${query.limit}`;
      }
    }
    return api.get(url);
  },
  save(employee: Employee) {
    if (employee.id) {
      return api.put(`/admin/employees/${employee.id}`, employee).then(r => r.employee);
    } else {
      return api.post(`/admin/employees`, employee).then(r => r.employee);
    }
  },
  put_login_perm(employeeId: number, allow_login: boolean) {
    return api.put(`/admin/employees/login/${employeeId}`, { allow_login: allow_login }).then(r => r.employee);
  },
  delete(employeeId: number) {
    return api.delete<void>(`/admin/employees/${employeeId}`);
  },
  resetPassword(employeeId: number) {
    return api.post<void>(`/admin/employees/${employeeId}/reset_password`);
  },
  syncDingtalk() {
    return api.post<void>(`/admin/sync-dingtalk`);
  },
  syncDingtalkOne(user_id: number) {
    return api.post<void>(`/admin/sync-dingtalk-one/${user_id}`);
  },
  leading_out(query: EmployeeOuterQuery) {
    let url = `/admin/outer_employees`;
    if (query) {
      url += `?name=${query.name}`;
      if (query.departmentId) {
        url += `&department_id=${query.departmentId}`;
      }
    }
    return api.get(url, {
      url: url,
      responseType: 'blob'
    });
  },
  leading_in(data: FormData) {
    return api.post<void>(`/admin/outer_employees`, data);
  },
  delete_account_lock(id: number) {
    return api.delete<void>(`/admin/lock/${id}`);
  },
  newMailAccount: (data: NewMailAccount) => {
    return api.post('/admin/mail-accounts', data);
  }
};
